import React from 'react'
import Toast from 'react-native-toast-message';

const useToast = () => {
    return Toast
}

export default useToast